import { uploadApi } from '../api/userProfileManager';
export default async (avatar, logger) => {
    const res = await uploadApi('post', { avatar }, `profile/{userId}/avatar`, {}, logger);
    return {
        hashCode: res.headers.get('etag')?.replace(/"/g, ''),
    };
};
